
import { Vue, Options, prop } from "vue-class-component";
import Modal from "./modal.vue";

class Props {
  isOpen = prop<boolean>({
    default: false
  });
}

@Options({
  emits: ["visibilityChange"],
  components: {
    Modal
  }
})
export default class Geolocation extends Vue.with(Props) {
  openModal() {
    this.$emit("visibilityChange", true);
  }

  closeModal() {
    this.$emit("visibilityChange", false);
  }
}
